import Button from '@material-ui/core/Button';
import styled from 'styled-components';

export default styled(Button)`
  && {
    color: #fff;
    border-color: #fff;
    text-transform: uppercase;
    margin-left: ${props => props.theme.spacing(3)}px;
  }
`;
